import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  IArchiveMeasurementRequest,
  IUpdateMeasurementRequest,
} from "../../../@types/admin/AdminMeasurement";
import { measurementsService } from "../../../services/admin";
import { ensureOk } from "../../../utils/ensureOk";
import { MEASUREMENTS_QUERY_KEY } from "../../queries/admin/measurements";

export function useUpdateMeasurement() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation<
    void,
    Error,
    { measurementId: number; request: IUpdateMeasurementRequest }
  >({
    mutationFn: async ({ measurementId, request }) =>
      ensureOk(
        await measurementsService.updateMeasurement(measurementId, request)
      ),
    onSuccess: () => {
      // The key carries the filters and page, so invalidate the whole list.
      queryClient.invalidateQueries({ queryKey: [MEASUREMENTS_QUERY_KEY] });
    },
  });

  return { updateMeasurement: mutateAsync, isUpdatingMeasurement: isPending };
}

export function useArchiveMeasurement() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation<
    void,
    Error,
    IArchiveMeasurementRequest
  >({
    mutationFn: async (request) =>
      ensureOk(await measurementsService.archiveMeasurement(request)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MEASUREMENTS_QUERY_KEY] });
    },
  });

  return { archiveMeasurement: mutateAsync, isArchivingMeasurement: isPending };
}
